module.exports = __webpack_public_path__ + "05_short_black.dd0fafbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/05_short_black.png
// module id = Zjv/
// module chunks = 0